import { combine } from 'effector'
import { selectEpgChannelModel } from '~/features/epg/channels/select'
import {
  $genericPlayerTranslations,
  $titlePlayerTranslations,
} from '~/shared/ui/translations/player-translations'

export const $epgPlayerTranslations = combine(
  {
    genericPlayerTranslations: $genericPlayerTranslations,
    titlePlayerTranslations: $titlePlayerTranslations,
    selectedEpgChannel: selectEpgChannelModel.$active,
  },
  ({
    genericPlayerTranslations,
    titlePlayerTranslations,
    selectedEpgChannel,
  }) => ({
    ...genericPlayerTranslations,
    ...titlePlayerTranslations(selectedEpgChannel?.name),
  })
)
